import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a3e23a06a4f2136474f95cf7eec9462f5b from "./generated-ea7c70c4-77f1-4608-a5dd-d5640b92cfcf.json";

import a2fa6f491a140953d51ed2b62e7e8d3e2b from "./generated-ad862df5-6c63-45b2-9243-2905846cd763.json";

import ae08eafa45143a4cfa56ad98b0ef3377eb from "./generated-3a2ee77d-aee3-453b-8073-6b67ca229f8a.json";

import a4be09fc594258d72687baba5b67d4907b from "./generated-cb33bd01-c624-4370-98f2-3b41c29238e8.json";

import ab774ef0d50a7bdbd461462579f3e5fd0b from "./generated-01112396-88d6-4b29-8285-910c7a6ccad1.json";

import a21ffa6abc78fb097b602de4c49aa05bfb from "./generated-c110ad17-c296-472b-accd-bafe8e0b1c83.json";

import a134caadb9526e018e82ffa533363b364b from "./generated-f29c3a05-ef3c-4c23-82c1-41df456424f3.json";

import a9ba3d8f9a76d564396fe40e82f94b6c8b from "./generated-b08edce8-562d-44a5-b8e9-fde5d2b89a09.json";

import a4f8e201784e4ae1b9479d513c77f5e01b from "./generated-270d8123-3f2f-44d3-b502-ccdefc5139fc.json";

import af50e399ebc64de0d686cc02ecb0d1681b from "./generated-b40fe093-9fa6-4a71-8b35-7f6d31b58e76.json";

import af7606961fe4c5f195bf463b15d702c74b from "./generated-8000e45d-a95e-4d1e-8db2-b97c1ded0673.json";

import a0acdb6164c2c3841bde5166c689b9ccfb from "./generated-badeb6ca-002f-4138-a0e4-0186fbad5411.json";

import a551d0dc08e1d81ae3259d122ce4a0974b from "./generated-9e569c7e-98ec-4bf1-bd62-ec71a8f9a489.json";

import a8fc72ad99efa984e193ef4cff26896adb from "./generated-f3e381ef-4073-4aa1-b33e-207634e79b97.json";

import a523ceb0565ad3868fca961d8596a8f3eb from "./generated-4aa470e8-c305-4c6a-858b-d2158829665d.json";

import a37eb3c044099e349a17e0c1398012061b from "./generated-2027185d-d638-49eb-813e-a450c5cf6f17.json";

import a79ab0e95c110b67c811761be5f65e1d3b from "./generated-553bb09f-3aad-4ab0-8e26-7ddec771aed2.json";

import a34d8e0235c11a0ff4bbef0d8c820ca57b from "./generated-9ec542ef-ebcd-4cd8-8ccb-37359df5f9af.json";

import a3c2bbdc0492d7db7e2b032ac145a930db from "./generated-bc1ac81b-dad1-4b99-8075-847c90a7e8dc.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a3e23a06a4f2136474f95cf7eec9462f5b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a2fa6f491a140953d51ed2b62e7e8d3e2b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ae08eafa45143a4cfa56ad98b0ef3377eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a4be09fc594258d72687baba5b67d4907b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ab774ef0d50a7bdbd461462579f3e5fd0b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a21ffa6abc78fb097b602de4c49aa05bfb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a134caadb9526e018e82ffa533363b364b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a9ba3d8f9a76d564396fe40e82f94b6c8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a4f8e201784e4ae1b9479d513c77f5e01b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(af50e399ebc64de0d686cc02ecb0d1681b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(af7606961fe4c5f195bf463b15d702c74b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a0acdb6164c2c3841bde5166c689b9ccfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a551d0dc08e1d81ae3259d122ce4a0974b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a8fc72ad99efa984e193ef4cff26896adb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a523ceb0565ad3868fca961d8596a8f3eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a37eb3c044099e349a17e0c1398012061b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a79ab0e95c110b67c811761be5f65e1d3b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a34d8e0235c11a0ff4bbef0d8c820ca57b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a3c2bbdc0492d7db7e2b032ac145a930db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a79ab0e95c110b67c811761be5f65e1d3b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */